import { Article } from '../articlesData';

export const articleFortrolighedsaftaleNdaSkabelon: Article = {
  id: 'fortrolighedsaftale-nda-skabelon-mitid',
  slug: 'fortrolighedsaftale-nda-skabelon-mitid',
  title: 'Fortrolighedsaftale (NDA): Skabelon og guide til juridisk bindende tavshedspligt',
  subtitle: 'Beskyt din virksomheds forretningshemmeligheder, idéer og know-how før det første møde. Lær hvad en god NDA skal indeholde, og få den underskrevet digitalt med det samme.',
  metaTitle: 'Fortrolighedsaftale (NDA) Skabelon: MitID Signering | KvikSign',
  metaDescription: 'Gratis skabelon til fortrolighedsaftale (NDA / Non-Disclosure Agreement). Beskyt fortrolige oplysninger og få juridisk bindende MitID-underskrift online.',
  canonicalUrl: 'https://kviksign.com/da/articles/fortrolighedsaftale-nda-skabelon-mitid',
  heroImage: 'https://firebasestorage.googleapis.com/v0/b/kviksign-db-europe/o/Website%2FPhotos%2FCasual%20work%20environment.webp?alt=media&token=f32203e2-8787-45ed-a53a-547f30452c8e',
  heroImageAlt: 'Fortrolighedsaftale og NDA dokument til digital underskrift med MitID',
  category: 'Kontrakter & Jura',
  author: {
    name: 'KvikSign',
    role: 'eID & Sikkerhedsteam',
    avatar: '/icon.svg'
  },
  publishedAt: '2026-10-14',
  updatedAt: '2026-10-14',
  readingTime: '6 min læsetid',
  keywords: [
    'fortrolighedsaftale skabelon',
    'nda skabelon dansk',
    'non disclosure agreement mitid',
    'tavshedspligt aftale skabelon',
    'gensidig fortrolighedsaftale',
    'fortrolighedserklæring erhverv',
    'digital signatur nda',
    'beskyttelse af forretningshemmeligheder'
  ],
  keyTakeaways: [
    'En Non-Disclosure Agreement (NDA) sikrer, at modparten ikke uberettiget kan udnytte eller videregive dine forretningshemmeligheder, kildekode, kundedata eller produktopskrifter.',
    'Lov om forretningshemmeligheder kræver, at du som virksomhedsejer har taget "rimelige foranstaltninger" for at hemmeligholde informationen – her er en underskrevet NDA det vigtigste bevis.',
    'Ensidige NDA\'er bruges, når kun den ene part fremlægger oplysninger (f.eks. til en investor eller potentiel køber), mens gensidige NDA\'er dækker begge parter i et innovationspartnerskab.',
    'Konventionalbod (fastsat bod ved brud på aftalen) er afgørende, da det i praksis er uhyre vanskeligt at opgøre og bevise det præcise økonomiske tab ved et datalæk.',
    'Med KvikSign kan NDA\'en underskrives af begge parter på under to minutter via MitID eller svensk BankID, så I kan gå til mødet med fuld juridisk tryghed.'
  ],
  tableOfContents: [
    { id: 'hvad-er-en-nda-og-hvorfor-er-den-noedvendig', title: 'Hvad er en NDA og hvorfor er den nødvendig?' },
    { id: 'ensidig-vs-gensidig-fortrolighedsaftale', title: 'Ensidig vs. gensidig fortrolighedsaftale' },
    { id: 'de-6-vigtigste-klausuler-i-en-god-nda', title: 'De 6 vigtigste klausuler i en god NDA' },
    { id: 'konventionalbod-hvorfor-en-standard-bod-er-afgoerende', title: 'Konventionalbod: Hvorfor en fast bod er afgørende' },
    { id: 'sadan-sikrer-du-hurtig-underskrift-med-mitid-og-bankid', title: 'Sådan sikrer du hurtig underskrift med MitID og BankID' },
    { id: 'download-gratis-nda-skabelon', title: 'Download gratis NDA skabelon' },
    { id: 'faq-fortrolighedsaftale', title: 'Ofte stillede spørgsmål om fortrolighedsaftaler' }
  ],
  sections: [
    {
      id: 'hvad-er-en-nda-og-hvorfor-er-den-noedvendig',
      title: 'Hvad er en NDA og hvorfor er den nødvendig?',
      paragraphs: [
        'En fortrolighedsaftale (også kendt som en NDA eller Non-Disclosure Agreement) er en juridisk bindende kontrakt mellem to eller flere parter, der fastlægger, hvordan fortrolige oplysninger skal behandles.',
        'Mange iværksættere og etablerede virksomheder begår den fejl at pitche unikke idéer, teknologier eller regnskabstal til investorer, samarbejdspartnere eller leverandører uden en forudgående aftale. Selvom lov om forretningshemmeligheder yder en vis beskyttelse, forudsætter loven, at virksomheden selv har taget aktive skridt til at hemmeligholde oplysningerne.',
        'En forudgående underskrevet NDA fjerner enhver tvivl om, at de udleverede oplysninger var fortrolige, og at modtageren var bevidst herom.'
      ]
    },
    {
      id: 'ensidig-vs-gensidig-fortrolighedsaftale',
      title: 'Ensidig vs. gensidig fortrolighedsaftale',
      paragraphs: [
        'Der sondres overordnet mellem to typer af aftaler:',
        '1. Ensidig NDA: Den ene part fremlægger følsomme oplysninger for den anden part. Det ses ofte, når en virksomhed viser sin software til en ekstern tester, eller når et selskab fremlægger kundelister for en potentiel opkøber.',
        '2. Gensidig NDA: Begge parter udveksler fortrolig viden for at undersøge muligheden for et fælles joint venture, opkøb eller strategisk partnerskab. Her pålægges begge parter de samme strenge tavshedsforpligtelser.'
      ]
    },
    {
      id: 'de-6-vigtigste-klausuler-i-en-god-nda',
      title: 'De 6 vigtigste klausuler i en god NDA',
      paragraphs: [
        'En effektiv fortrolighedsaftale skal være præcis og dækkende på følgende punkter:',
        '• Definition af fortrolige oplysninger: Hvilke data, dokumenter, prototyper og samtaler er omfattet?',
        '• Formål: Hvad må modtageren anvende informationen til (f.eks. udelukkende til at evaluere et muligt samarbejde)?',
        '• Undtagelser: Oplysninger der allerede var offentligt kendte eller lovligt modtaget fra tredjemand.',
        '• Varighed: Hvor længe gælder tavshedspligten (typisk 2 til 5 år efter aftalens indgåelse)?',
        '• Tilbagelevering eller sletning: Pligt til at slette alle kopier ved samarbejdets ophør.',
        '• Lovvalg og værneting: Hvilken domstol skal afgøre eventuelle tvister (f.eks. Københavns Byret efter dansk ret).'
      ]
    },
    {
      id: 'konventionalbod-hvorfor-en-standard-bod-er-afgoerende',
      title: 'Konventionalbod: Hvorfor en fast bod er afgørende',
      paragraphs: [
        'Hvis modparten lækker dine forretningshemmeligheder, er det i praksis ekstremt vanskeligt at løfte bevisbyrden for dit nøjagtige økonomiske tab ved en retssag. Hvor meget mistede du i omsætning, fordi en konkurrent lancerede et tilsvarende produkt?',
        'Derfor indsættes ofte en konventionalbod (f.eks. 100.000 kr. eller 250.000 kr. per overtrædelse). Med en forud fastsat bod skal du blot bevise, at der er sket et brud på fortroligheden – du behøver ikke dokumentere dit præcise tab.'
      ]
    },
    {
      id: 'sadan-sikrer-du-hurtig-underskrift-med-mitid-og-bankid',
      title: 'Sådan sikrer du hurtig underskrift med MitID og BankID',
      paragraphs: [
        'At printe, underskrive, scanne og maile en NDA inden et vigtigt møde virker umoderne og skaber unødig friktion. Med KvikSign kan du sende aftalen direkte til modpartens mobilnummer eller e-mail.',
        'Modparten bekræfter sin identitet og underskriver med MitID (i Danmark) eller BankID (i Sverige) på under 60 sekunder. Aftalen forsegles med en digital tidsstempling, så I har et uafviseligt bevis for, at tavshedspligten var etableret forud for mødestart.'
      ]
    },
    {
      id: 'download-gratis-nda-skabelon',
      title: 'Download gratis NDA skabelon',
      paragraphs: [
        'KvikSign stiller en gratis, juridisk afstemt skabelon til både ensidig og gensidig fortrolighedsaftale til rådighed. Skabelonen kan tilpasses frit og uploades direkte til signering i KvikSign.'
      ]
    }
  ],
  faqs: [
    {
      question: 'Hvor længe bør en NDA gælde?',
      answer: 'En typisk fortrolighedsaftale gælder i 2 til 3 år fra underskriftstidspunktet. For særligt kritisk kildekode eller produktionsteknik kan forpligtelsen fastsættes til 5 år eller uden tidsbegrænsning.'
    },
    {
      question: 'Kan en NDA underskrives med svensk BankID?',
      answer: 'Ja. KvikSign understøtter både dansk MitID og svensk BankID, hvilket gør det let at indgå grænseoverskridende nordiske fortrolighedsaftaler.'
    },
    {
      question: 'Er en digitalt underskrevet NDA juridisk gyldig i retten?',
      answer: 'Ja. Digitale signaturer med eID (MitID/BankID) er fuldt retsgyldige i overensstemmelse med EU-forordningen eIDAS og de nordiske aftalelove.'
    }
  ],
  sources: [
    { title: 'Lov om forretningshemmeligheder', url: 'https://www.retsinformation.dk' },
    { title: 'Dansk Erhverv - Guide til NDA og hemmeligholdelse', url: 'https://www.danskerhverv.dk' }
  ],
  disclaimer: 'Denne skabelon og vejledning er til generel information og erstatter ikke professionel advokatbistand. Ved store strategiske transaktioner anbefales altid individuel juridisk rådgivning.'
};
